import * as types from '@/vuex/types';
import * as subfixFun from '@/vuex/subfix';
import {Loading} from "element-ui";
export function generateUUID() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return uuid.replace(new RegExp('-', "gm"), '');
};

//自定义标题长度
export function formattedTitle(title) {
  if (title.length > 20) {
    return title.substring(0, 20) + "..."
  } else {
    return title
  }
}


//自定义学号长度
export function formattedStuNo(stuNo) {
  if (stuNo.length > 10) {
    return stuNo.substring(0, 10) + "..."
  } else {
    return stuNo
  }
}

//自定义题型格式化
export function formattedName(name, length) {
  if (!length) {
    length = 5;
  }
  if (name.length > length) {
    return name.substring(0, length) + "..."
  } else {
    return name
  }
}

//自定义题型格式化
export function formatName(name, length) {
  if (name.length > length) {
    return name.substring(0, length) + "..."
  } else {
    return name
  }
}

//自定义截取字符串
export function customizedCuttingStr(str, length) {
  if (str.length > length) {
    return str.substring(0, length) + "...";
  } else {
    return str;
  }
}

// 播放时用
export function showFullPath(path, subfix) {
  if (path == undefined) {
    return '';
  }
  if (!isNull(path) && path.substr(0, 4) == "http") {
    return path;
  }
  return types.FILE_SERVER_URL + path;
}

// 显示封面
export function showThumbPath(path, subfix) {
  if (subfix == "game") {
    return require('@/assets/images/game.jpg');
  }
  if (!isNull(path) && path.substr(0, 4) == "http") {
    return path;
  }
  let showPath = types.FILE_SERVER_URL + path;
  switch (subfix) {
    case "game":
      return require('@/assets/images/game.jpg');
    case "jpg":
    case "jpeg":
    case "png":
    case "jif":
    case "mp4":
    case "video":
    case "flash":
    case "swf":
    case "header":
      if (showPath === "null") {
        return require('@/assets/images/default/personal_info.jpg')
      }
      return showPath;
    case "doc":
    case "docx":
      return require('@/assets/images/word.png');
    case "ppt":
    case "pptx":
      return require('@/assets/images/ppt.png');
    case "pdf":
      return require('@/assets/images/pdf.png');
    default:
      return require('@/assets/images/default/img_default.png');
  }
}

/**
 * 返回课件页类型
 * @returns
 */
export function getCwPageContentType(subfix) {
  //图片形式播放
  if (subfixFun.play_with_img(subfix)) {
    return types.CW_PAGE_CONTENT_TYPE.img;
  }
  // flash形式播放
  if (subfixFun.play_with_flash(subfix)) {
    return types.CW_PAGE_CONTENT_TYPE.flash;
  }
  // video形式播放
  if (subfixFun.play_with_video(subfix)) {
    return types.CW_PAGE_CONTENT_TYPE.video;
  }
  // pdf形式播放
  if (subfixFun.play_with_pdf(subfix)) {
    return types.CW_PAGE_CONTENT_TYPE.pdf;
  }
}

/**
 * 返回课件页内容的样式
 * @returns
 */
export function getDisplayClass(subfix) {
  if (subfixFun.display_by_img(subfix)) {
    return "photo";
  }
  if (subfixFun.display_by_video(subfix)) {
    return "video";
  }
  if (subfixFun.display_by_flash(subfix)) {
    return "flash";
  }
  if (subfixFun.display_by_doc(subfix)) {
    return "word";
  }
  if (subfixFun.display_by_ppt(subfix)) {
    return "ppt";
  }
  if (subfixFun.display_by_pdf(subfix)) {
    return "pdf";
  }
}

export const isNull = (data) => {
  return (data == "" || data == undefined || data == null) ? true : false;
}

export const isNotNull = (data) => {
  return (data != "" || data != undefined || data != null) ? true : false;
}

export const collectionIsNull = (data) => {
  return (typeof (data) == "undefined" || data == null || Object.keys(data).length === 0) ? true : false;
}

// 判断字符串为空
export const isEmpty = (val) => {
  return val == null || val.length === 0 || val === '';
}
export const isNotEmpty = (val) => {
  return val != null || val.length !== 0 || val !== '';
}

export function getDuration(remarks) {
  if (isNull(remarks)) {
    return "";
  } else {
    let value = JSON.parse(remarks);
    var theTime = parseInt(value.duration);// 秒
    var theTime1 = 0;// 分
    var theTime2 = 0;// 小时
    // alert(theTime);
    if (theTime > 60) {
      theTime1 = parseInt(theTime / 60);
      theTime = parseInt(theTime % 60);
      // alert(theTime1+"-"+theTime);
      if (theTime1 > 60) {
        theTime2 = parseInt(theTime1 / 60);
        theTime1 = parseInt(theTime1 % 60);
      }
    }

    var result = "" + parseInt(theTime) >= 10 ? parseInt(theTime) : ("0" + parseInt(theTime));
    if (theTime1 > 0) {
      result = "" + (parseInt(theTime1) >= 10 ? parseInt(theTime1) : ("0" + parseInt(theTime1))) + ":" + result;
    } else {
      result = "00:" + result;
    }
    if (theTime2 > 0) {
      result = "" + (parseInt(theTime2) >= 10 ? parseInt(theTime2) : ("0" + parseInt(theTime2))) + ":" + result;
    }
    return result
  }
}

export function number2Char(number) {
  return String.fromCharCode(64 + parseInt(number));
}

export function getTopicTypeMeaning(type) {
  if (type == "1") {
    return "单选题";
  } else if (type == "2") {
    return "多选题";
  } else if (type == "3") {
    return "判断题";
  } else if (type == "9") {
    return "凭证表格题";
  }
}

//深拷贝
export function deepCopy(o, c) {
  var c = c || {}
  for (var i in o) {
    if (typeof o[i] === 'object' && o[i] != null) {
      //要考虑深复制问题了
      if (o[i].constructor === Array) {
        //这是数组
        c[i] = []
      } else {
        //这是对象
        c[i] = {}
      }
      deepCopy(o[i], c[i])
    } else {
      c[i] = o[i]
    }
  }
  return c
}

//将c对象中的值赋给o,o原先的字段不变。//此方法报错
export function deepConvert(o, c) {
  var c = c || {}
  for (var i in o) {
    if (typeof o[i] === 'object') {
      //要考虑深复制问题了
      if (o[i].constructor === Array) {
        //这是数组
        c[i] = []
      } else {
        //这是对象
        c[i] = {}
      }
      deepConvert(o[i], c[i])
    } else if (typeof c[i] != 'undefined') {
      c[i] = o[i]
    }
  }
  return c
}

export function getUrlParam(url, paraName) {
  var arrObj = url.split("?");
  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split("&");
    var arr;
    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");
      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return "";
  } else {
    return "";
  }
}

export function findFileType(name) {
  return name.substr(name.lastIndexOf(".") + 1, name.length);
}

export function findClassByFileType(fileName) {
  let fileType = findFileType(fileName);
  fileType = fileType.substr(0, 3);
  return fileType == "doc" ? "word" : fileType;
}

//格式化授课教案数据
export function formatData(data) {
  // 1. 授课教案数据
  var step = [];
  // 2. 资源一览数据
  var resourceList = [];

  for (let i = 0; i < data.length; i++) {
    var page = data[i];
    var stepPage = {
      x: i * 2000,
      y: 0,
      z: 0,
      rotateX: 0,
      rotateY: 0,
      rotateZ: 0,
      id: 'Step' + i,
      bgPic: '/static/img/course_bg.32b0de4.png',
      props: {
        subs: []
      }
    }
    let subs = [];
    let process_name = {
      "type": 'process_name', "content": page.name == null ? '' : page.name, "subfix": ''
    };
    subs.push(process_name);
    //格式化文字
    let process_teach_content = {
      "type": 'process_teach_content', "content": page.teachContent == null ? '' : page.teachContent, "subfix": ''
    };
    subs.push(process_teach_content);
    //格式化资源格式
    for (let j = 0; j < page.tResourceList.length; j++) {
      let subResource = {
        "type": page.tResourceList[j].type, "resource": {
          "givingResourceId": page.tResourceList[j].givingTpProcessResourceId,
          "thumbPath": page.tResourceList[j].thumbPath,
          "resourceId": page.tResourceList[j].id,
          "path": page.tResourceList[j].path,
          "subfix": page.tResourceList[j].subfix,
          "name": page.tResourceList[j].name,
          "isSend": page.tResourceList[j].isSend
        }
      }
      // 授课页资源和资源一览的资源，指向同一地址，统一发送状态
      subs.push(subResource);
      resourceList.push(subResource);
    }

    //当页面试题为空的时候，设置isSend为空，否则js报错
    let isSend = ""
    if (page.exercisesList != null && page.exercisesList.length > 0) {
      isSend = page.exercisesList[0].isSend
    } else {
      isSend = ""
    }
    //格式化试题
    let process_paper = {
      "type": 'process_paper',
      "exerciseslength": page.exercisesList.length,
      "subfix": '',
      "exercisesEntity": page.exercisesList.length != undefined ? page.exercisesList[0] : null,
      "isSend": isSend
    };
    if (page.exercisesList != null && page.exercisesList.length > 0) {
      process_paper.exercisesEntity.exerciseslength = process_paper.exerciseslength;
    }
    subs.push(process_paper);
    if (page.exercisesList.length > 0) {
      resourceList.push(process_paper);
    }
    stepPage.props.subs = subs;
    step.push(stepPage);
  }

  return {
    "step": step, "resourceList": resourceList
  };
}

/**
 * 判断List是空List
 */
export function isEmptyList(list) {
  if (list == null || typeof (list) == "undefined" || list.length == 0) {
    return true;
  }
  return false;
}

export function padLeftZero(str) {
  return ('00' + str).substr(str.length);
};

export function formatDate(date, fmt) {
  fmt = isNull(fmt) ? "yyyy-MM-dd hh:mm" : fmt;
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
};

export function formatDateDay(date, fmt) {
  fmt = isNull(fmt) ? "yyyy-MM-dd" : fmt;
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
};

/**
 * 时间转换
 */
export function formatTime(time) {
  if (time == null) {
    return;
  }
  let seconds = parseInt(time);// 秒
  // 时
  let hour = parseInt(seconds / 3600);
  hour = hour.length >= 2 ? hour : "0" + hour;
  // 分
  let min = parseInt((seconds % 3600) / 60) + "";
  min = min.length >= 2 ? min : "0" + min;
  // 秒
  let second = parseInt((seconds % 3600) % 60) + "";
  second = second.length >= 2 ? second : "0" + second;
  return (hour + ":" + min + ":" + second);
}

export function iAnrray(stringToSearch, arrayToSearch) {
  for (let s = 0; s < arrayToSearch.length; s++) {
    let thisEntry = arrayToSearch[s].toString();
    if (thisEntry == stringToSearch) {
      return true;
    }
  }
  return false;
}

/**
 * 将时间格式化为当前时区时间
 * @param dateStr
 * @returns {*}
 */
export function toLocalTimeByZoneNum(dateStr) {
  try {
    let date = new Date(dateStr);
    let offset = Math.floor(new Date().getTimezoneOffset() * 60000)
    date.setTime(date.getTime() - offset);
    /*return this.formatDate1(date);*/
    if (date == null) {
      return;
    }
    let d = new Date(date);
    let hour = d.getHours();
    let min = d.getMinutes();
    let mon = d.getMonth() + 1;
    let day = d.getDate();
    if (mon < 10) {
      mon = '0' + mon;
    }
    if (day < 10) {
      day = '0' + day;
    }
    if (hour < 10) {
      hour = '0' + hour;
    }
    if (min < 10) {
      min = '0' + min;
    }
    return d.getFullYear() + '-' + mon + '-' + day + ' ' + hour + ':' + min;
  } catch (ex) {
    return dateStr;
  }
}

// by sw start
// 删除所有HTML标签
export function removeHtmlTab(tab) {
  return tab.replace(/<[^<>]+?>/g, '');
}

//转意符换成普通字符
export function escape2Html(str) {
  var arrEntities = {'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"'};
  return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) {
    return arrEntities[t];
  });
}

export function nbsp2Space(str) {
  var arrEntities = {'nbsp': ' '};
  return str.replace(/&(nbsp);/ig, function (all, t) {
    return arrEntities[t]
  })
}

// by sw end

// 画线将（靠左，靠下）的点作为起点
export function setLineStartPoint(line) {
  let changeStartEnd = false;
  if (line.start_left > line.end_left) {
    changeStartEnd = true;
  } else if (line.start_left == line.end_left && line.start_top < line.end_top) {
    changeStartEnd = true;
  }
  if (changeStartEnd) {
    let temp = line.end_left;
    line.end_left = line.start_left;
    line.start_left = temp;
    temp = line.end_top;
    line.end_top = line.start_top;
    line.start_top = temp;
  }
}

// 移除小数点最后的0
export function remove0AfterDecimalPoint(number) {
  let regexp = /(?:\.0*|(\.\d+?)0+)$/;
  if (!number) {
    return number;
  }
  return number.replace(regexp, '$1');
}

//学生答题
export function showFileValidPath(path, remarks) {
  let showPath = "";
  switch (remarks) {
    case "word":
      showPath = "/static/img/word.png";
      break;
    case "ppt":
      showPath = "/static/img/ppt.png";
      break;
    case "pdf":
      showPath = "/static/img/pdf.png";
      break;
    case "video":
      showPath = "/static/img/2.jpg";
      break;
    default:
      showPath = types.FILE_SERVER_URL + path;
      break;
  }
  return showPath;
}

//根据文件名后缀区分 文件类型
/*
       * @param: fileName - 文件名称
       * @param: 数据返回 1) 无后缀匹配 - false
       * @param: 数据返回 2) 匹配图片 - image
       * @param: 数据返回 3) 匹配 txt - txt
       * @param: 数据返回 4) 匹配 excel - excel
       * @param: 数据返回 5) 匹配 word - word
       * @param: 数据返回 6) 匹配 pdf - pdf
       * @param: 数据返回 7) 匹配 ppt - ppt
       * @param: 数据返回 8) 匹配 视频 - video
       * @param: 数据返回 9) 匹配 音频 - radio
       * @param: 数据返回 10) 其他匹配项 - other
       */
export function matchType(fileName) {
// 后缀获取
  var suffix = '';
  // 获取类型结果
  var result = '';
  try {
    var flieArr = fileName.split('.');
    suffix = flieArr[flieArr.length - 1];
  } catch (err) {
    suffix = '';
  }
  // fileName无后缀返回 false
  if (!suffix) {
    result = false;
    return result;
  }
  // 图片格式
  var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
  // 进行图片匹配
  result = imglist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'image';
    return result;
  }
  ;
  // 匹配txt
  var txtlist = ['txt'];
  result = txtlist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'txt';
    return result;
  }
  ;
  // 匹配 excel
  var excelist = ['xls', 'xlsx'];
  result = excelist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'excel';
    return result;
  }
  ;
  // 匹配 word
  var wordlist = ['doc', 'docx'];
  result = wordlist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'word';
    return result;
  }
  ;
  // 匹配 pdf
  var pdflist = ['pdf'];
  result = pdflist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'pdf';
    return result;
  }
  ;
  // 匹配 ppt
  var pptlist = ['ppt'];
  result = pptlist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'ppt';
    return result;
  }
  ;
  // 匹配 视频
  var videolist = ['mp4', 'm2v', 'mkv'];
  result = videolist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'video';
    return result;
  }
  ;
  // 匹配 音频
  var radiolist = ['mp3', 'wav', 'wmv'];
  result = radiolist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'radio';
    return result;
  }
  // 其他 文件类型
  result = 'other';
  return result;
}


// IOS使用时间
export function formatDateIOS(timestamp) {
  let times = timestamp.replace(/-/g, "/");
  let dateTime = new Date(times);
  let year = dateTime.getFullYear();
  let month = (dateTime.getMonth() + 1) < 10 ? ("0" + (dateTime.getMonth() + 1)) : (dateTime.getMonth() + 1);
  let date = dateTime.getDate() < 10 ? ("0" + dateTime.getDate()) : dateTime.getDate();
  let hour = dateTime.getHours() < 10 ? ("0" + dateTime.getHours()) : dateTime.getHours();
  let minute = dateTime.getMinutes() < 10 ? ("0" + dateTime.getMinutes()) : dateTime.getMinutes();
  let second = dateTime.getSeconds() < 10 ? ("0" + dateTime.getSeconds()) : dateTime.getSeconds();

  return year + "/" + month + "/" + date + " " + hour + ":" + minute + ":" + second;
}

// 分钟转小时
export function minTime(min) {
  let minTime = "";
  let h = Math.floor(min / 60);
  min -= h * 60;
  if (min < 0) {
    minTime = min + "分钟";
  } else {
    minTime = (h ? h + "小时" : "") + (min ? min + "分钟" : "");
  }
  return minTime;
}

export default {
  minTime(min) {
    return minTime(min);
  }, isNull(data) {
    return isNull(data);
  }, isEmpty(data) {
    return isEmpty(data)
  }, isNotNull(data) {
    return isNotNull(data);
  }, isNotEmpty(data) {
    return isNotEmpty(data)
  }, collectionIsNull(data) {
    return collectionIsNull(data);
  }, generateUUID() {
    return generateUUID();
  }, formattedTitle(title) {
    return formattedTitle(title);
  }, formattedStuNo(stuNo) {
    return formattedStuNo(stuNo);
  }, formattedName(name, length) {
    return formattedName(name, length);
  }, formatName(name, length) {
    return formatName(name, length);
  }, customizedCuttingStr(name, length) {
    return customizedCuttingStr(name, length);
  }, showFullPath(path, remarks) {
    return showFullPath(path, remarks);
  }, showThumbPath(path, remarks) {
    return showThumbPath(path, remarks);
  }, getDuration(remarks) {
    return getDuration(remarks);
  }, number2Char(number) {
    return number2Char(number);
  }, getTopicTypeMeaning(type) {
    return getTopicTypeMeaning(type);
  }, deepCopy(source, target) {
    return deepCopy(source, target);
  }, deepConvert(source, target) {
    return deepConvert(source, target);
  }, findFileType(name) {
    return findFileType(name);
  }, findClassByFileType(name) {
    return findClassByFileType(name);
  }, getUrlParam(url, paraName) {
    return getUrlParam(url, paraName);
  }, formatDate(date, fmt) {
    return formatDate(date, fmt);
  }, formatDateIOS(date) {
    return formatDateIOS(date);
  }, formatDateDay(date, fmt) {
    return formatDateDay(date, fmt);
  }, formatData(data) {
    return formatData(data);
  }, isEmptyList(list) {
    return isEmptyList(list);
  }, formatTime(time) {
    return formatTime(time);
  }, getCwPageContentType(subfix) {
    return getCwPageContentType(subfix);
  }, getDisplayClass(subfix) {
    return getDisplayClass(subfix);
  }, iAnrray(str, arr) {
    return iAnrray(str, arr);
  }, removeHtmlTab(tab) {
    return removeHtmlTab(tab);
  }, escape2Html(str) {
    return escape2Html(str);
  }, nbsp2Space(str) {
    return nbsp2Space(str);
  }, formatDate1(date) {
    return formatDate1(date);
  }, toLocalTimeByZoneNum(dateStr) {
    return toLocalTimeByZoneNum(dateStr);
  }, setLineStartPoint(line) {
    return setLineStartPoint(line);
  }, remove0AfterDecimalPoint(number) {
    return remove0AfterDecimalPoint(number);
  },

  // 字符串逗号分隔转换成数组
  stringToArr(str){
    let arr = []
    let arrStr = str.split(',')
    for (var key in arrStr) {
      arr.push(arrStr[key])
    }
    return arr
  },

  //学生答题
  showFileValidPath(path, remarks) {
    return showFileValidPath(path, remarks);
  },

  //根据文件名后缀区分 文件类型
  matchType(fileName) {
    return matchType(fileName);
  },

  // 文件播放路径
  getPlayPath(path) {
    return types.FILE_SERVER_URL + path;
  },

  // 请求成功回调
  isSuccess(res, callBack) {
    if (types.STATUS_OK === res.msgCode) {
      callBack()
    }
  },
  // 请求失败回调
  isError(res, callBack){
    if (types.STATUS_OK !== res.msgCode) {
      callBack()
    }
  },

  // 获取近五年年级名
  getLastFiveYears() {
    const currentYear = new Date().getFullYear();
    const fiveYearsAgo = currentYear - 4; // 近五年的起始年份
    const years = [];
    for (let i = fiveYearsAgo; i <= currentYear; i++) {
      years.push({
        id: i,
        label: i + '级',
      });
    }
    return years.reverse()
  },

  showLoading(options) {
    return Loading.service({
      text: '加载中...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)', ...options
    });
  },

  closeLoading() {
    this.showLoading().close()
  }
}



// WEBPACK FOOTER //
// ./src/utils.js